





































































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import BudgetSubItem from "@/models/porposal/budgetSubItem.model";
@Component
export default class BudgetSubItemAdd extends GenericAdd<BudgetSubItem> {
  constructor() {
    super();
    this.controller = "BudgetSubItem";
    this.model = new BudgetSubItem();
  }
  protected async validate() {
    try {
      this.model.budgetItemId = this.$route.params.budgetItemId as any;
      var result = await this.$validator.validateAll();
      if (result) {
        this.add();
        return;
      }
      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
    }
  }
}
